module.exports = __webpack_public_path__ + "static/media/signupDone.f9274134.gif";